import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import Logo from "../../assets/logos/logo.png";
import ChangeLanguage from "../../components/ChangeLanguage";
import { ENV } from "../../configs/env";

const LogoBanner = styled(Box)(
    () => `
      height: 100%;
      display: flex;
      justify-content: space-between;
      height: 50px;
      width: -webkit-fill-available;
      align-items: center;
      padding: 20px 0 10px 0px;
      & .logo {
        width: 170px;
        height: 28px;
      }
      & .cancelBtn {
        font-weight: 500
      }
    `,
);

const LogoHeader = ({ enableLanguage }: { enableLanguage?: boolean }) => {
  return !ENV.HIDE_LOGO
  ? (
        <LogoBanner>
            <img
                className="logo"
                src={
                    process.env.REACT_APP_LOGO
                        ? "/assets/logo/" + process.env.REACT_APP_LOGO
                        : Logo
                }
                alt="logo"
            />
            {!ENV.HIDE_TRANSLATOR && enableLanguage && <ChangeLanguage />}
        </LogoBanner>
    )
  :
  null;
};

export default LogoHeader;
